module.exports = __webpack_public_path__ + "static/media/The terrace Alcoves 8.bfa73033.jpg";